/**
 * @file error-handler.js
 * @description Tratamento de erros da API para CRA
 */

/**
 * @class FetchError
 * @description Classe de erro customizada para requisições HTTP
 */
export class FetchError extends Error {
  constructor(message, status, code, details) {
    super(message)
    this.name = "FetchError"
    this.status = status
    this.code = code
    this.details = details
  }
}

/**
 * Trata erros de fetch
 * @param {Response} response - Resposta da requisição
 * @throws {FetchError}
 */
export async function handleFetchError(response) {
  let errorData = null

  try {
    const contentType = response.headers.get("content-type")
    if (contentType && contentType.includes("application/json")) {
      errorData = await response.json()
    } else {
      errorData = { message: await response.text() }
    }
  } catch (error) {
    errorData = { message: "Erro ao processar resposta do servidor" }
  }

  const message =
    errorData?.message ||
    errorData?.error ||
    `Erro ${response.status}: ${response.statusText}`

  throw new FetchError(
    message,
    response.status,
    errorData?.code || `HTTP_${response.status}`,
    errorData
  )
}
